import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'secret-vault',
});

export const createNamespaceRouteRef = createRouteRef({
  id: 'secret-vault-create-namespace',
});
